import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const Heading2 = ({ node }: RichTextContentProps) => {
  return (
    <h2>
      <RichTextContent node={node} />
    </h2>
  );
};

export default Heading2;
